import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Inbox, Plus } from 'lucide-react';

/**
 * Empty state component for when there's no data to display
 */
const EmptyState = ({
  icon: Icon = Inbox,
  title = 'No data found',
  description = 'There are no items to display.',
  action,
  actionLabel = 'Add New',
  actionIcon: ActionIcon = Plus,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        textAlign: 'center',
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: 'action.hover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <Icon size={40} color="currentColor" style={{ color: 'inherit' }} />
      </Box>

      <Typography variant="h6" fontWeight={600} gutterBottom>
        {title}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 360, mb: action ? 3 : 0 }}
      >
        {description}
      </Typography>

      {action && (
        <Button
          variant="contained"
          startIcon={<ActionIcon />}
          onClick={action}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
